<template>
  <div>
    <Title
      :title-text="`${$t('forgotPassword_title')}`"
      :text="`${$t('forgotPassword_title_text')}`"
      data-qa="por-forgot--title" />
    <ForgotPasswordForm data-qa="por-forgot--form" />
  </div>
</template>

<script>
import { track } from '@/services/tracking'

import ForgotPasswordForm from '@/components/forms/forgot'
import Title from '@/components/title'

export default {
  name: 'ForgotPassword',
  components: {
    ForgotPasswordForm,
    Title
  },
  mounted () {
    track({ name: 'page view', params: { module: 'forgot password' } })
  }
}
</script>
